import React from "react";
import PrinterLeftTextInput from "./PrinterLeftTextInput";
import PrinterRightTextInput from "./PrinterRightTextInput";
import PrinterCalendar from "./PrinterCalendar";
import PrinterMiddleLogoInput from "./PrinterMiddleLogoInput";
import PrinterEnableSave from "./PrinterEnableSave";

type Props = {};

const PrinterTimeTable = (props: Props) => {
  return (
    <div className="flex justify-center">
      <PrinterLeftTextInput />
      <div className="border-2 border-gray-100  ">
        <div className="flex items-center ">
          <PrinterMiddleLogoInput />
          <PrinterEnableSave />
        </div>
        <PrinterCalendar />
      </div>
      <PrinterRightTextInput />
    </div>
  );
};

export default PrinterTimeTable;
